/** Meal row on templates / target plans (diet API field). */
export const getMealFoodId = (food) => food?.food_id ?? null;

/** Row in the recipe catalog (DietDB / fetchRecipes). */
export const getRecipeCatalogId = (recipe) =>
  recipe?.recipe_id ?? recipe?.id ?? recipe?.food_unique_id ?? null;

/** Display name from catalog detail, embedded recipe_details, or meal row. */
export const getRecipeName = (item) =>
  item?.recipe_name ||
  item?.food_name ||
  item?.name ||
  item?.common_names ||
  item?.common_name ||
  "";

export const getRecipeDetails = (item) => item?.recipe_details ?? null;

/** Target-plan food row from daily tracking API (`target_food_id` → canonical `food_id`). */
export function mealFoodFromTrackingTarget(food) {
  if (!food?.target_food_id) return null;
  return {
    ...food,
    food_id: food.target_food_id,
    recipe_details: food.recipe_details ?? food.target_recipe_details,
  };
}

/** Tracked actual intake row from daily tracking API. */
export function mealFoodFromTrackingActual(food) {
  if (!food?.actual_food_id) return null;
  return {
    ...food,
    food_id: food.actual_food_id,
    recipe_details: food.recipe_details ?? food.actual_recipe_details,
    quantity: food.actual_quantity ?? food.quantity ?? food.target_quantity,
    quantity_type:
      food.actual_quantity_type ??
      food.actual_quantity_type_description ??
      food.quantity_type ??
      food.target_quantity_type ??
      food.target_quantity_type_description,
    quantity_type_id:
      food.actual_quantity_type_id ??
      food.quantity_type_id ??
      food.target_quantity_type_id,
  };
}

export function recipeDetailFromMap(detailsMap, foodId) {
  if (foodId == null || !detailsMap) return null;
  return detailsMap[String(foodId)] ?? detailsMap[foodId] ?? null;
}

/** Card display fields for tracked foods (name + actual quantity/unit). */
export function resolveTrackedFoodDisplay(food, detailsMap = {}) {
  const normalized = food?._original
    ? mealFoodFromTrackingActual(food._original)
    : mealFoodFromTrackingActual(food) || food;
  const foodId = normalized?.food_id ?? food?.food_id;
  const detail = recipeDetailFromMap(detailsMap, foodId);

  const foodName =
    getRecipeName(detail) ||
    getRecipeName(getRecipeDetails(normalized)) ||
    (food?.food_name && !String(food.food_name).startsWith("Recipe ")
      ? food.food_name
      : "") ||
    (foodId ? `Recipe ${String(foodId).slice(0, 8)}` : "Unknown food");

  return {
    foodName,
    quantity: normalized?.quantity ?? food?.quantity ?? 1,
    quantityType: normalized?.quantity_type ?? food?.quantity_type ?? "g",
  };
}
